<template>
  <div class="createBankAccount">
    <div class="topBakBox">
      <TopBack :title="topTitle"/>
    </div>
    <div class="waringBox">
      <div v-if="isEdit" class="warning">{{ $t('lang.account.createBankAccountWarning') }}</div>
    </div>
    <div class="formBox">
      <div class="formItem">
        <div class="label">{{ $t('lang.account.holderName') }}</div>
        <input v-model="accountInfo.AccountName" type="text" @input="onAccountNameInput"
               :placeholder="$t('lang.account.holderNameTips')">
      </div>
      <div class="formItem">
        <div class="label">{{ $t('lang.account.accountNo') }}</div>
        <input v-model="accountInfo.AccountNumber" type="text" :placeholder="$t('lang.account.accountNo')">
      </div>
      <div class="formItem">
        <div class="label">Bank Code （IFSC Code)</div>
        <input v-model="accountInfo.BankCode" type="text" :placeholder="$t('lang.account.IFSC')">
      </div>
      <div @click="outLink" class="itemTip">{{ $t('lang.account.outLink') }}</div>
      <div class="formImageItem">
        <img :src="cardInfo" alt="">
      </div>
      <div class="claim" @click="setAccount">{{ $t('lang.setting.save') }}</div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import {Toast} from 'mint-ui'
import request from '../../service'
import cardInfo from '@/assets/images/account/cardInfo.webp'
import {InternationAccountNumberReg, InternationBankList, InternationIDCardReg, InternationIFSCReg} from '@/constant'

export default {
  name: 'createBankAccount',
  components: {
    TopBack
  },
  data () {
    return {
      cardInfo,
      isEdit: false,
      topTitle: this.$t('lang.menu.' + this.$route.name),
      bankListSlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center'
        }
      ],
      IFSCReg: RegExp(/^[A-Za-z]{4}[0]\w{6}$/),
      AccountNameReg: RegExp(/^[a-zA-Z]+( [a-zA-Z]+)+$/),
      AccountNumberReg: RegExp(/^\d{8,18}$/),
      AadhaarReg: RegExp(/^\d{12}$/),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      accountInfo: {
        Id: null,
        AccountName: null,
        AccountNumber: null,
        BankCode: null,
        BankCardVerifyStatus: null
      },
      personalInfo: {
        fullName: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.FullName : null,
        cardNum: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.AadhaarCardNumber : null,
        Birthday: '',
        mobile: ''
      },
      InternationBankList,
      InternationIFSCReg,
      InternationAccountNumberReg,
      InternationIDCardReg
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.accountInfo) {
      this.accountInfo = this.$route.query.accountInfo
      this.isEdit = true
    }
    this.title = this.$t('lang.account.withdrawSetup.textYourBank')
    // 2022-02-17 CHP 根据国家版本设置相关信息
    this.bankListSlots[0].values = this.InternationBankList.getBankList(this.$store.state.internation)
    this.IFSCReg = this.InternationIFSCReg.getReg(this.$store.state.internation)
    this.AccountNumberReg = this.InternationAccountNumberReg.getReg(this.$store.state.internation)
  },
  methods: {
    onAccountNameInput (e) {
      let value = e.target.value
      value = value.replace(/[^a-zA-Z ]/g, '')
      this.accountInfo.AccountName = value
    },
    setAccount () {
      if (!this.accountInfo.AccountName || !this.accountInfo.AccountName.trim()) {
        Toast(this.$t('lang.account.withdrawSetup.promptFillAccountName'))
      } else if (!this.AccountNameReg.test(this.accountInfo.AccountName.trim()) || this.accountInfo.AccountName.trim().length < 5 || this.accountInfo.AccountName.trim().length > 60) {
        Toast(this.$t('lang.account.withdrawSetup.promptInvalidAccountName'))
      } else if (!this.accountInfo.AccountNumber) {
        Toast(this.$t('lang.account.withdrawSetup.promptFillAccountNumber'))
      } else if (!this.AccountNumberReg.test(this.accountInfo.AccountNumber)) {
        Toast(this.$t('lang.account.withdrawSetup.promptInvalidAccount'))
      } else if (!this.accountInfo.BankCode) {
        Toast(this.$t('lang.account.withdrawSetup.promptFillIFSC'))
      } else if (!this.IFSCReg.test(this.accountInfo.BankCode)) {
        Toast(this.$t('lang.account.withdrawSetup.promptInvalidCard'))
      } else {
        const url = '/innovation/account/set/userbankaccount'
        const data = {
          UserId: this.userInfo.UserId,
          AccountName: this.accountInfo.AccountName.trim(),
          AccountNumber: this.accountInfo.AccountNumber,
          BankCode: this.accountInfo.BankCode,
          Id: this.accountInfo.Id
        }
        request('post', url, data).then(res => {
          Toast(res.Message)
          if (res.Code > 0) {
            this.accountInfo = {
              Id: null,
              AccountName: null,
              AccountNumber: null,
              BankCode: null,
              BankCardVerifyStatus: null
            }
            this.$router.back()
          }
        }).catch(err => {
          console.log(err)
          Toast(this.$t('lang.account.withdrawSetup.errorUpload'))
        })
      }
    },
    outLink () {
      if (window.Android) {
        window.Location.href = 'https://bankifsccode.com/'
      } else {
        window.open('https://bankifsccode.com/', '_blank')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.createBankAccount {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;

  .waringBox {
    display: flex;
    justify-content: center;

    .warning {
      margin-top: 2.777vw;
      font-weight: 400;
      text-align: center;
      animation: blink .6s linear 2;
      height: 10.55vw;
      line-height: 10.55vw;
      width: 92.94vw;
      background: rgba(110, 10, 10, 0.41);
      color: #D32F13;
      font-size: 2.77vw;
      border-radius: 1.666vw;
      overflow: hidden;
      overflow-y: auto;
    }
  }

  .topBakBox {
    padding-top: 4vw;
  }

  .formBox {
    height: max-content;
    width: 100%;
    padding: 2vw 5vw;
    display: flex;
    flex-direction: column;
    gap: 4vw;
    margin-top: 5vw;

    .itemTip {
      display: flex;
      justify-content: flex-end;
      padding-right: 2vw;
      font-size: 3.88vw;
    }

    .claim {
      background-color: #F6D9AA;
      color: #000D2E;
      font-size: 5vw;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 1.388vw;
      height: 11.954vw;
      width: 84vw;
      margin: auto;
    }

    .formImageItem {
      margin: 4vw 0;
      width: 61.666vw;
      height: max-content;

      img {
        width: 100%;
        height: auto;
      }
    }

    .formItem {
      display: flex;
      flex-direction: column;

      .label {
        color: #F6D9AA;
        font-size: 4.72vw;
        padding-bottom: 2vw;
      }

      input {
        width: 100%;
        height: 10.83vw;
        border: 1px solid rgb(133, 119, 95);
        border-radius: 1.111vw;
        text-align: right;
        padding-right: 2vw;
        color: #F6D9AA;
        font-size: 4.72vw;
      }

      input::placeholder {
        font-size: 4.44vw;
      }
    }
  }
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WithdrawalSuccessful/createBankAccount.vue